var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.top),expression:"top"}],staticClass:"top header",on:{"click":_vm.istop}},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/向上.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }